"use client";
import { MultiPurposeParagraph } from "@/components/Atoms/Paragraph";
import Image from "@/components/Atoms/Image";
import { useTranslation } from "next-i18next";
import styles from "./index.module.scss";
import { useMediaQuery } from "../EstateMap";
import { LocationMapView } from "./LocationMapView";

export default function SectionLocation(data: any) {
  const { t } = useTranslation();
  const [width] = useMediaQuery();

  return (
    <>
      {data.locationType === "block" ? (
        <div
          style={{ backgroundColor: data.backgroundColor?.hex }}
          className="section w-full"
        >
          <div className="container max-w-[1360px] mx-auto grid grid-cols-1 xl:grid-cols-3 gap-12 py-12">
              {data.content.map((entry: any, i: number) => (
                <div key={i} className="col-span-1 flex flex-col gap-4 ">
                  {entry.isPhysicalAdress && (
                    <>
                      <a
                        className="flex flex-col gap-4 "
                        href={entry.googleMapsLocation}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className={styles.contactTitle}>
                          <Image data={entry?.icon} />
                          <MultiPurposeParagraph
                            type="subLabel"
                            data={t("location")}
                            color={data.fontColor}
                          />
                        </div>

                        <MultiPurposeParagraph
                          type="image"
                          data={entry.address}
                          color={data.fontColor}
                        />
                      </a>
                    </>
                  )}
                  {entry.isEContacts && (
                    <>
                      <div className={styles.contactTitle}>
                        <Image data={entry?.icon} />
                        <MultiPurposeParagraph
                          type="subLabel"
                          data={t("contacts")}
                          color={data.fontColor}
                        />
                      </div>

                      <div className="flex flex-row gap-2">
                        <MultiPurposeParagraph
                          type="image"
                          data={`${t("email")}: ${entry.email}`}
                          color={data.fontColor}
                        />
                      </div>
                      <div className="flex flex-row gap-2">
                        <MultiPurposeParagraph
                          type="image"
                          data={`${t("mobile")}: ${entry.mobile}`}
                          color={data.fontColor}
                        />
                      </div>
                      <div className="flex flex-row gap-2">
                        <MultiPurposeParagraph
                          type="image"
                          data={`${t("telephone")}: ${entry.telephone}`}
                          color={data.fontColor}
                        />
                      </div>
                    </>
                  )}
                  {entry.isSchedule && (
                    <>
                      <div className={styles.contactTitle}>
                        <Image data={entry?.icon} />
                        <MultiPurposeParagraph
                          type="subLabel"
                          data={t("schedule")}
                          color={data.fontColor}
                        />
                      </div>
                      <div className="flex flex-row gap-2">
                        <MultiPurposeParagraph
                          type="image"
                          data={entry.timeFrames}
                          color={data.fontColor}
                        />
                      </div>
                    </>
                  )}
                </div>
              ))}
          </div>
        </div>
      ) : (
        <div
          className="relative w-full"
          style={{ backgroundColor: data?.backgroundColor?.hex }}
        >
          <LocationMapView
            id={data.id}
            locationType={data.locationType}
            location={data.location}
            mapIcon={data.mapIcon}
            mapAccentColor={data.mapAccentColor}
            mapStylePreset={data.mapStylePreset}
            mapTileStyle={data.mapTileStyle}
            sectionFontColor={data.fontColor?.hex}
            width={width}
          />
        </div>
      )}
    </>
  );
}

export const fragment = `
    fragment SectionLocationFragment on SectionLocationsMapRecord{
      __typename
      id
      locationType
      name
      useSectionMargins
      useExtraTopMargins
      useExtraPadding
      location{
        latitude
        longitude
      }
      mapIcon {
        img {
          url
          alt
          width
          height
        }
      }
      mapAccentColor {
        hexCode
        color {
          hex
          cssRgb
        }
      }
      mapStylePreset
      mapTileStyle
      fontColor{
        hex
      }
      backgroundColor{
        hex
      }
      content {
        icon{
          url
          width
          height
        }
        isPhysicalAdress
        isSchedule
        isEContacts
        email
        mobile
        telephone
        address
        googleMapsLocation
        timeFrames
      }
    }
`;
